import {
  Box,
  Button,
  Flex,
  Image,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Spinner,
} from "@chakra-ui/react";
import checkEmail from "@root/assets/images/checkEmail.svg";
import { DeleteAccount as DeleteAccountSvg } from "@root/assets/images/deleteAccount";
import { SignOut as SignOutSvg } from "@root/assets/images/sign-out";
import { LinkText } from "@root/commonStyles/commonStyle";
import {
  CustomOutLinedButton,
  CustonButtom,
} from "@root/components/common/button/customButton";
import { CustomText } from "@root/components/common/components";
import { CenterFlexGap } from "@root/components/dashboard/chat/style";
import { useTranslation } from "react-i18next";
import { CheckEmailDescription } from "./auth/checkEmail/styles";
import {
  StyledDeletePopupContainer,
  CheckYourEmailHeading,
  CheckYourEmailDesc1,
  CheckYourEmailDesc2,
} from "./style";
import { ROUTE_NAMES } from "@root/constants";
import { TFunction } from "i18next";
import { BrandedLogo } from "@root/components/branding";
import { DeleteAccIcon } from "@root/assets";

export const DeletePopupContent = (props: any) => {
  const { loading, onCancel, onDelete } = props;
  const { t } = useTranslation("common");
  return (
    <StyledDeletePopupContainer>
      <Image src={DeleteAccIcon} />
      <CustomText
        fontSize={"18px"}
        fontWeight={500}
        textAlign={"center"}
        text={t("delete.content")}
      />
      <CustomText
        type="grayText"
        fontSize={"16px"}
        textAlign={"center"}
        whiteSpace={"pre-line"}
        text={t("delete.description")}
      />
      <CenterFlexGap>
        <CustomOutLinedButton
          fontSize="14px"
          borderRadius="8px"
          color="black"
          border={"1px solid black"}
          height="40px"
          width="52px"
          text={t("delete.cancel")}
          onClick={onCancel}
        />
        <CustonButtom
          isLoading={loading}
          text={t("delete.confirm")}
          bg="theme.danger.200"
          height="40px"
          color="white"
          borderRadius="8px"
          onClick={onDelete}
        />
      </CenterFlexGap>
    </StyledDeletePopupContainer>
  );
};

export const LogoutPopupContent = (props: any) => {
  const { onCancel, onSignOut } = props;
  const { t } = useTranslation("common");
  return (
    <StyledDeletePopupContainer>
      <SignOutSvg />
      <CustomText
        pt={"8px"}
        fontSize={"24px"}
        fontWeight={500}
        textAlign={"center"}
        text={t("logout.title")}
      />
      <CustomText
        type="grayText"
        fontSize={"16px"}
        textAlign={"center"}
        whiteSpace={"pre-line"}
        text={t("logout.description")}
      />
      <CenterFlexGap py={"6px"}>
        <CustomOutLinedButton text={t("logout.confirm")} onClick={onSignOut} />
        <CustomOutLinedButton text={t("logout.cancel")} onClick={onCancel} />
      </CenterFlexGap>
    </StyledDeletePopupContainer>
  );
};

export const ThresholdPopupContent = (props: any) => {
  const { sliderValue = 0, handleSliderChange, onSet, onCancel } = props;
  const { t } = useTranslation("common");
  return (
    <StyledDeletePopupContainer alignItems={"flex-start"}>
      <CustomText
        fontSize={"24px"}
        fontWeight={500}
        text={t("setThreshold.content")}
      />
      <Flex justifyContent={"space-between"} width={"100%"}>
        <CustomText text="0%" fontSize={"16px"} />
        <CustomText text="100%" fontSize={"16px"} />
      </Flex>
      <Slider
        aria-label="slider-ex-1"
        defaultValue={50}
        value={sliderValue || 0}
        onChange={handleSliderChange}
      >
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb boxSize={8}>
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            width={"auto"}
            px={"10px"}
            height={"34px"}
            border={"1px solid"}
            bg={"#FFF"}
            borderRadius={"100px"}
            borderColor={"gray.600"}
          >
            <CustomText
              color={"#000"}
              text={`${sliderValue || 0}%`}
              fontSize={"12px"}
              fontWeight={500}
            />
          </Flex>
        </SliderThumb>
      </Slider>
      <CustomText
        type="grayText"
        fontSize={"16px"}
        text={t("setThreshold.description")}
      />
      <CenterFlexGap py={"6px"} width={"100%"}>
        <CustomOutLinedButton
          text={t("setThreshold.cancel")}
          onClick={onCancel}
          minW={"118px"}
          justifyContent={"center"}
          alignItems={"center"}
        />
        <CustonButtom
          fontSize="14px"
          height="44px"
          text={t("setThreshold.set")}
          onClick={onSet}
          minW={"118px"}
          justifyContent={"center"}
          alignItems={"center"}
        />
      </CenterFlexGap>
    </StyledDeletePopupContainer>
  );
};

const RenderContent = (
  loading: boolean,
  onResend: () => void,
  t: TFunction
) => {
  if (loading) {
    return (
      <Flex my={"20px"}>
        <Spinner />
      </Flex>
    );
  } else {
    return (
      <Flex alignItems={"center"} mt={"18px"}>
        <CustonButtom
          py={"10px"}
          colorScheme="purple"
          justifyContent={"center"}
          size="md"
          alignItems={"center"}
          text={t("translate.resendBtnText")}
          onClick={onResend}
          background={"purple.purpleGradient"}
          width={"105px"}
          borderRadius={"16px"}
        />
      </Flex>
    );
  }
};

// Check your Email
export const VerifyYourEmailAfterSignup = ({
  email,
  onResend,
  loading,
}: any) => {
  const { t } = useTranslation("common");
  return (
    <Flex flexDir={"column"} alignItems={"center"}>
      <Box mt={"5rem"} mb={"15px"}>
        <BrandedLogo variant="full" />
      </Box>
      <Image src={checkEmail} alt="forgetpassword" mt="26px" />
      <CheckYourEmailHeading>
        {t("translate.pleaseVerify")}
      </CheckYourEmailHeading>

      <CheckYourEmailDesc1>
        {t("translate.verifyDesc1", { email })}
      </CheckYourEmailDesc1>
      <CheckYourEmailDesc2>{t("translate.verifyDesc2")}</CheckYourEmailDesc2>
      {RenderContent(loading, onResend, t)}
      <LinkText
        my="38px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="8px"
        to={ROUTE_NAMES.FORGET_PASSWORD}
      >
        {t("checkEmail.differentEmail")}
      </LinkText>
    </Flex>
  );
};

export const VerifyYourEmailAfterReset = ({
  email,
  loading,
  onResend,
}: any) => {
  const { t } = useTranslation("common");
  return (
    <Flex
      flexDir={"column"}
      alignItems={"center"}
      gap={"16px"}
      maxW={{ base: "90%", sm: "600px" }}
    >
      <Box mt={"5rem"} mb={"15px"}>
        <BrandedLogo variant="full" />
      </Box>

      <Image src={checkEmail} alt="Lock" />
      <CustomText
        textAlign={"center"}
        fontSize={"32px"}
        text={t("translate.pleaseVerify")}
        fontWeight={500}
      />
      <CheckEmailDescription>
        {t("checkEmail.thanksIf")}

        <LinkText
          fontSize={{ base: "12px", md: "16px" }}
          fontWeight={"400"}
          to={""}
          mx={"6px"}
        >
          {email || ""}
        </LinkText>

        {t("checkEmail.description")}
      </CheckEmailDescription>
      <CustomText
        textAlign={"center"}
        type="grayText"
        fontSize={"16px"}
        text={t("translate.checkAfter5Mins")}
      />
      <Button
        isLoading={loading}
        onClick={onResend}
        mt="32px"
        size={"md"}
        colorScheme="purple"
        width="104px"
        background="linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)"
        _hover={{
          background: "linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)",
        }}
      >
        {t("checkEmail.resend")}
      </Button>
      <LinkText my="38px" to={"/forgot-password"}>
        {t("checkEmail.differentEmail")}
      </LinkText>
    </Flex>
  );
};
